import LoginForm from "@/model/Form/LoginForm"
import { ref, Ref } from "vue"
import email from "@/state/email"

const loginForm: Ref<LoginForm> = ref(new LoginForm(email.value))

export default loginForm
